module.exports = __webpack_public_path__ + "img/logo.771a4163.png";